import { render, staticRenderFns } from "./DetailMember.vue?vue&type=template&id=1041411e"
import script from "./DetailMember.vue?vue&type=script&lang=js"
export * from "./DetailMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports